import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Navbar.css';

const Navbar = () => {
  const [isActive, setIsActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // On Home at top: transparent nav with white text. Everywhere else: solid nav with dark text so header is always readable.
  const isHomeAtTop = location.pathname === '/' && !scrolled;
  const useSolidNav = !isHomeAtTop;

  const toggleMenu = () => setIsActive(!isActive);
  const closeMenu = () => setIsActive(false);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/services', label: 'Services' },
    { to: '/portfolio', label: 'Portfolio' },
    { to: '/internship', label: 'Internship' },
    { to: '/career', label: 'Career' },
    { to: '/contact', label: 'Contact' },
    { to: '/support', label: 'Support' },
  ];

  return (
    <motion.nav
      className={`navbar ${useSolidNav ? 'navbar--scrolled' : ''}`}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="nav-logo" onClick={closeMenu}>
            <img src="/logicsphere-logo.png" alt="LogicSphere Logo" className="logo-icon" />
            <div className="logo-text-container">
              <span className="logo-text">LogicSphere</span>
              <span className="logo-subtitle">Technologies</span>
            </div>
          </Link>

          <ul className={`nav-menu ${isActive ? 'active' : ''}`}>
            {navLinks.map(({ to, label }) => (
              <li key={to} className="nav-item">
                <Link to={to} className="nav-link" onClick={closeMenu}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          <button
            type="button"
            className={`nav-toggle ${isActive ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isActive}
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
